import cn from 'classnames';
import {extendTailwindMerge} from 'tailwind-merge';

// Unlisted keys are unmergeable, so a local `p-0` cannot override `pb-safe-or-8`. `safe-offset-sticky-header`
// stays out on purpose: pages rely on it beating a later `pt-*` through CSS source order.
const SPACING_VALUE = /^(?:[\d.]+(?:-hw-offset)?|safe|safe-(?:or|offset)-(?:[\d.]+|\[.+\]))$/;

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{text: ['14']}],
            padding: [
                // This tells twMerge that `pt-0`, `pt-1`, ... and `pt-0-hw-offset`, `pt-1-hw-offset` are in same group
                {pt: ['hw-offset']},
            ],
        },
        conflictingClassGroups: {
            pt: ['pt'], // ensure it knows pt conflicts with itself (default, but we reinforce)
        },
        theme: {
            spacing: (value) => SPACING_VALUE.test(value),
        },
    },
});

export const twx = (...props) => twMerge(cn(props));
